// extracted by mini-css-extract-plugin
export default {"HomeWrapper":"Home_HomeWrapper__-+741","homelogodevfolio":"Home_homelogodevfolio__6SM6m","homeFooter":"Home_homeFooter__IhXPX"};